module.exports = __webpack_public_path__ + "img/13.21f489d5.jpg";